import { memo, useState } from 'react';
// @mui
import {
  Button,
  Stack,
  Typography,
} from '@mui/material';
// hooks
import useCompany from '../../hooks/useCompany';
// components
import Avatar from '../../components/Avatar';
import { CrewProfileDialog } from './';

// ----------------------------------------------------------------------

function CrewAvatar({ crewId, width=24, height=24, nameVariant="body1", sx={}, clickable=false }) {
  const { crews } = useCompany();
  const crew = crews.find(crew => crew.id === parseInt(crewId)) || {};
  const { randomhash, nickname } = crew;
  const [openProfileDialog, setOpenProfileDialog] = useState(false);

  if (!randomhash || isNaN(randomhash)) return null;
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ overflow: 'hidden', ...sx }}>
      <Avatar
        src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${randomhash || '5'}.png`}
        alt={nickname}
        color={'default'}
        sx={{
          width: width,
          height: height,
        }}
      />
      {crew.is_active && clickable && (
        <Button
          disableFocusRipple size="small" onClick={() => setOpenProfileDialog(true)}
          sx={{ fontWeight: 400, whiteSpace: 'nowrap', lineHeight: 1.5, fontSize: '1rem', textTransform: 'none' }}
        >
          <b>{nickname}</b>&nbsp;크루
        </Button>
      )}
      {(!crew.is_active || !clickable) && (
        <Typography variant={nameVariant} noWrap sx={{ textOverflow: 'ellipsis' }}>
          <b>{nickname}</b> 크루
        </Typography>
      )}
      <CrewProfileDialog
        isOpen={openProfileDialog}
        closeDialog={() => setOpenProfileDialog(false)}
        crew={crew}
      />
    </Stack>
  )
}

export default memo(CrewAvatar);
